module.exports = __webpack_public_path__ + "img/moneyback.2575e350.png";